import CookieBar from './cookies/bar/CookieBar';
import CookiePage from './cookies/page/CookiePage';
import Calculator from "@modules/forms/Templates/Calculator/Calculator.js";

const Modules = {

	init() {
		CookieBar.init();
		CookiePage.init();
		Calculator.init();
	},

	resize() {
	},

	setByUrl(path, search) {
	},
};

export default Modules;